import { Injectable } from '@angular/core';
import * as fromReducer from './../state/reducers';
import * as spinnerActions from './../state/actions/spinner.action';

import { Store } from '@ngrx/store';
@Injectable({
	providedIn: 'root'
})
export class SpinnerService {

	constructor(private store: Store<fromReducer.State>) {
	}

	requestCount: number = 0;

	show() {
		if (this.requestCount == 0) {
			this.store.dispatch(spinnerActions.Show());
		}
		this.requestCount = this.requestCount + 1;
	}

	hide() {
		if (this.requestCount == 1) {
			this.store.dispatch(spinnerActions.Hide());
		}
		this.requestCount = this.requestCount - 1;
	}
}
